import { db } from '../config/firebase';
import {
  collection, getDocs, getDoc, doc, addDoc, updateDoc, deleteDoc, serverTimestamp,
} from 'firebase/firestore';
import { swissPairing } from './pairing';

// ══════════════════════════════════════════════════════════════════════
//  MASHINDANO YA OFISINI — chess ya wafanyakazi, kila wiki
//  Wachezaji 4 hadi 20, raundi kadhaa, mshindi Ijumaa. Admin ndiye
//  anayeendesha; anaweza kumteua staff mmoja kama MSIMAMIZI wa
//  mashindano fulani (anapata ruhusa sawa na admin kwa mashindano
//  hayo pekee). Staff wengine wote ni WATAZAMAJI — wanaona standings
//  na matokeo lakini hawawezi kubadilisha chochote.
//
//  MUHIMU: Wachezaji WANAONGEZWA KWA JINA, si kwa kuchagua akaunti.
//  Hii inaepuka kabisa hitaji la kusoma collection ya 'users' (ambayo
//  staff hawaruhusiwi kuisoma yote) — ndiyo iliyokuwa ikivunja ukurasa.
//  Msimamizi anateuliwa kutoka akaunti halisi (uid) na ADMIN pekee,
//  kwa sababu ndipo panapohitajika kuunganisha na akaunti ya kuingia.
// ══════════════════════════════════════════════════════════════════════

const COLLECTION = 'officeTournaments';

export async function fetchOfficeTournaments() {
  const snap = await getDocs(collection(db, COLLECTION));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }))
    .sort((a, b) => (b.createdAt?.seconds || 0) - (a.createdAt?.seconds || 0));
}

export async function fetchOfficeTournament(id) {
  const s = await getDoc(doc(db, COLLECTION, id));
  return s.exists() ? { id: s.id, ...s.data() } : null;
}

function slugId(name) {
  return `${name.trim().toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '')}-${Math.random().toString(36).slice(2, 6)}`;
}

export async function createOfficeTournament({ title, participantNames, totalRounds, author }) {
  const participants = participantNames.map(n => ({ id: slugId(n), name: n.trim() }));
  const ref = await addDoc(collection(db, COLLECTION), {
    title,
    participants, // [{ id, name }]
    rounds: [],   // [{ number, pairings: [{whiteId,whiteName,blackId,blackName,result}], byeId, byeName }]
    totalRounds: Number(totalRounds) || suggestedRounds(participants.length),
    status: 'ongoing',
    winnerId: null,
    winnerName: null,
    refereeId: null,
    refereeName: null,
    createdBy: author.uid,
    createdByName: author.name,
    createdAt: serverTimestamp(),
  });
  return ref.id;
}

// Idadi ya raundi inayopendekezwa kwa mfumo wa Swiss — kanuni ya kawaida
// ni raundi za kutosha kutofautisha kila mtu: log2(wachezaji), angalau 3.
export function suggestedRounds(participantCount) {
  if (!participantCount || participantCount < 2) return 3;
  return Math.max(3, Math.ceil(Math.log2(participantCount)));
}

export async function updateTotalRounds(tournamentId, totalRounds) {
  await updateDoc(doc(db, COLLECTION, tournamentId), {
    totalRounds: Number(totalRounds) || 1,
    updatedAt: serverTimestamp(),
  });
}

// Ongeza mchezaji kwenye mashindano yanayoendelea (mtu aliyekuja baadaye)
export async function addParticipant(tournamentId, name) {
  const t = await fetchOfficeTournament(tournamentId);
  if (!t) throw new Error('Mashindano hayakupatikana.');
  const exists = (t.participants || []).some(p => p.name.trim().toLowerCase() === name.trim().toLowerCase());
  if (exists) throw new Error('Mchezaji huyu tayari yupo kwenye mashindano haya.');
  const participants = [...(t.participants || []), { id: slugId(name), name: name.trim() }];
  await updateDoc(doc(db, COLLECTION, tournamentId), { participants, updatedAt: serverTimestamp() });
  return participants;
}

export async function removeParticipant(tournamentId, participantId) {
  const t = await fetchOfficeTournament(tournamentId);
  if (!t) throw new Error('Mashindano hayakupatikana.');
  const played = (t.rounds || []).some(r =>
    r.byeId === participantId || (r.pairings || []).some(p => p.whiteId === participantId || p.blackId === participantId)
  );
  if (played) throw new Error('Mchezaji huyu tayari amecheza — huwezi kumwondoa. Futa raundi zake kwanza.');
  const participants = (t.participants || []).filter(p => p.id !== participantId);
  await updateDoc(doc(db, COLLECTION, tournamentId), { participants, updatedAt: serverTimestamp() });
  return participants;
}

// ── Msimamizi wa mashindano (referee) — Admin pekee anateua ───────────
export async function assignReferee(tournamentId, refereeId, refereeName) {
  await updateDoc(doc(db, COLLECTION, tournamentId), {
    refereeId: refereeId || null, refereeName: refereeName || null,
    updatedAt: serverTimestamp(),
  });
}

export async function addRound(tournamentId, round) {
  const t = await fetchOfficeTournament(tournamentId);
  if (!t) throw new Error('Mashindano hayakupatikana.');
  const rounds = [...(t.rounds || []), { ...round, number: (t.rounds?.length || 0) + 1 }];
  await updateDoc(doc(db, COLLECTION, tournamentId), { rounds, updatedAt: serverTimestamp() });
  return rounds;
}

export async function updateRound(tournamentId, roundNumber, round) {
  const t = await fetchOfficeTournament(tournamentId);
  if (!t) throw new Error('Mashindano hayakupatikana.');
  const rounds = (t.rounds || []).map(r => r.number === roundNumber ? { ...round, number: roundNumber } : r);
  await updateDoc(doc(db, COLLECTION, tournamentId), { rounds, updatedAt: serverTimestamp() });
  return rounds;
}

export async function removeRound(tournamentId, roundNumber) {
  const t = await fetchOfficeTournament(tournamentId);
  if (!t) throw new Error('Mashindano hayakupatikana.');
  const rounds = (t.rounds || [])
    .filter(r => r.number !== roundNumber)
    .map((r, i) => ({ ...r, number: i + 1 })); // renumber ili raundi ziendane
  await updateDoc(doc(db, COLLECTION, tournamentId), { rounds, updatedAt: serverTimestamp() });
  return rounds;
}

export async function declareWinner(tournamentId, winnerId, winnerName) {
  await updateDoc(doc(db, COLLECTION, tournamentId), {
    status: 'completed', winnerId, winnerName,
    completedAt: serverTimestamp(),
  });
}

export async function reopenTournament(tournamentId) {
  await updateDoc(doc(db, COLLECTION, tournamentId), {
    status: 'ongoing', winnerId: null, winnerName: null, completedAt: null,
  });
}

export async function deleteOfficeTournament(id) {
  await deleteDoc(doc(db, COLLECTION, id));
}

// ══════════════════════════════════════════════════════════════════════
//  SWISS PAIRING — kupanga raundi inayofuata kiotomatiki
//  Injini halisi iko kwenye utils/pairing.js (inatumika pia na IFR).
//  Hapa tunaandaa tu standings + historia kwa umbo linalohitajika.
// ══════════════════════════════════════════════════════════════════════
export function generateSwissRound(tournament) {
  const standings = computeStandings(tournament);
  const playedPairs = new Set();
  const byeHistory = new Set();
  (tournament.rounds || []).forEach(r => {
    (r.pairings || []).forEach(p => playedPairs.add(`${[p.whiteId, p.blackId].sort().join('__')}`));
    if (r.byeId) byeHistory.add(r.byeId);
  });
  return swissPairing({ standings, playedPairs, byeHistory });
}

// ── Kuhesabu standings kutoka raundi zote ───────────────────────────────
// Ushindi = pointi 1, sare = 0.5, kushindwa = 0, bye = pointi 1.
// Pia tunahesabu ni mara ngapi kila mtu amecheza akiwa Weupe na Weusi —
// hii ndiyo "kete" (rangi) aliyotumia kila mchezo.
export function computeStandings(tournament) {
  const totals = {};
  (tournament.participants || []).forEach(p => {
    totals[p.id] = {
      id: p.id, name: p.name, points: 0, wins: 0, draws: 0, losses: 0,
      games: 0, whiteCount: 0, blackCount: 0, byes: 0,
    };
  });

  (tournament.rounds || []).forEach(round => {
    (round.pairings || []).forEach(p => {
      if (!p.result || !totals[p.whiteId] || !totals[p.blackId]) return;
      totals[p.whiteId].games++; totals[p.blackId].games++;
      totals[p.whiteId].whiteCount++; totals[p.blackId].blackCount++;
      if (p.result === '1-0') {
        totals[p.whiteId].points += 1; totals[p.whiteId].wins++;
        totals[p.blackId].losses++;
      } else if (p.result === '0-1') {
        totals[p.blackId].points += 1; totals[p.blackId].wins++;
        totals[p.whiteId].losses++;
      } else if (p.result === '½-½') {
        totals[p.whiteId].points += 0.5; totals[p.whiteId].draws++;
        totals[p.blackId].points += 0.5; totals[p.blackId].draws++;
      }
    });
    if (round.byeId && totals[round.byeId]) {
      totals[round.byeId].points += 1;
      totals[round.byeId].byes++;
    }
  });

  return Object.values(totals).sort((a, b) => {
    if (b.points !== a.points) return b.points - a.points;
    if (b.wins !== a.wins) return b.wins - a.wins;
    return a.name.localeCompare(b.name);
  });
}
